module.exports = __webpack_public_path__ + "d1a5193c4d4cd9f45bedc4d88b05572f.svg";